<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageTemplates.title') }}
    </portal>
    <template v-if="templates !== null">
      <template v-for="templateType in enums['TemplateDocument']">
        <card v-if="templateDocuments[templateType].systemTemplate === false"
              :ref="templateType"
              :title="$t(`TemplateDocument.${templateType}`)"
              :key="templateType"
              :collapsed="templateType !== 'ReservationConfirmationEmail'"
              cols="12"
              card-type="collapsible">
          <hm-card-inner :full-size="true">
            <hm-col cols="12">
              <template v-for="template in templates" v-if="template.documentType === templateType && !template.deleted">
                <hm-card-inner-line :title="getName(template)" :clickable="true" :key="template.id" @click="routeToTemplate(template)" />
              </template>
            </hm-col>
          </hm-card-inner>
        </card>
      </template>

      <card v-if="!isEmpty(deletedTemplates)" :title="$t('admin.pageTemplate.card.deletedTemplates')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="template in deletedTemplates"
                              :title="getName(template)"
                              :clickable="true"
                              :key="template.id"
                              @click="routeToTemplate(template)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageTemplates.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button v-if="hotelSettings.details.onlineBookingSettings.enabled && !isEmpty(hotelSettings.details.onlineBookingSettings.defaultReservationConfirmationTemplateId)"
                                  :label="`${$t('admin.pageTemplates.actions.addTemplate')}: ${$t(`TemplateDocument.ReservationConfirmationEmail`)}`"
                                  icon="plus"
                                  color="blue"
                                  @click="addTemplate('ReservationConfirmationEmail')" />
        <hm-floating-child-button :label="`${$t('admin.pageTemplates.actions.addTemplate')}: ${$t(`TemplateDocument.GuestOfferDocument`)}`" icon="plus" color="blue" @click="addTemplate('GuestOfferDocument')" />
        <hm-floating-child-button :label="`${$t('admin.pageTemplates.actions.addTemplate')}: ${$t(`TemplateDocument.GenericEmail`)}`" icon="plus" color="blue" @click="addTemplate('GenericEmail')" />
        <hm-floating-child-button :label="`${$t('admin.pageTemplates.actions.addTemplate')}: ${$t(`TemplateDocument.GenericDocument`)}`" icon="plus" color="blue" @click="addTemplate('GenericDocument')" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import TemplateMixin from '@/mixins/TemplateMixin';

export default {
  name: 'PageTemplates',

  components: {
    draggable,
  },

  mixins: [HotelmeisterMixin, TemplateMixin],

  data() {
    return {
    };
  },

  computed: {
    deletedTemplates: function () {
      return isNil(this.templates) ? null : this.templates.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    addTemplate(type = 'GenericEmail') {
      this.axios.post(this.serviceUrls.template.list(this), {
        name: this.$t('admin.pageTemplates.newTemplateName'),
        title: {
          [this.hotelSettings.details.primaryLanguage]: '',
        },
        templateContent: {
          [this.hotelSettings.details.primaryLanguage]: '',
        },
        documentType: isEmpty(type) ? 'GenericEmail' : type,
        deleted: false,
      })
        .then((response) => {
          this.loadTemplateList();
          this.$serviceBus.$emit('hotelSettings.update');

          try {
            const card = this.$refs[type][0];
            if (!isNil(card) && card.isCollapsed) {
              card.toggleCollapse();
            }
            // eslint-disable-next-line no-empty
          } catch (ignore) { }
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(template) {
      const name = isNil(template) ? null : template.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name;

      // let details = '';
      //
      // if (template.deleted === false) {
      //   //TODO: add details in the future
      // }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      // ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return '-';
    },
    routeToTemplate(template) {
      this.$router.push({
        name: 'template',
        params: {
          templateId: template.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageTemplates.vue